/**
 * Route definition for /chains/coston-2
 *
 * Renders the shared ChainPage with the `coston-2` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/coston-2
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/coston-2')({
  component: function Coston2ChainPage() {
    return <ChainPage slug="coston-2" />
  },
})
